import React, { FC } from 'react'
import { interpolateCertificates } from 'shared/interpolate'
import { Box, Flex } from '@chakra-ui/react'
import { DownloadCertificationAsPdf } from './DownloadCertificationAsPdf'
import { OrientationEnum } from '../../graphql/public/PublicSchemaTypes'

interface CertificateRenderInput {
  organisation: string
  fullName: string
  firstName: string
  lastName: string
  email: string
  title: string
  authorOfSource: string
  awardedDate: string
  expiryDate: string
}

export const Certificate: FC<{
  svg: string
  orientation: OrientationEnum
  variables: CertificateRenderInput
}> = ({ svg, variables, orientation }) => {
  const output = svg ? interpolateCertificates(svg, variables) : ''
  const previewAreaRef = React.useRef<HTMLDivElement>(null)
  return (
    <>
      <Flex mt={'40px'} justifyContent="center">
        <Box
          ref={previewAreaRef}
          boxShadow={'8px 8px 8px 0 rgba(104,128,139,0.20)'}
          lineHeight={0}
          dangerouslySetInnerHTML={{
            __html: output
          }}
        />
      </Flex>
      <Box m="auto" w="fit-content" mt="15px">
        <DownloadCertificationAsPdf
          orientation={orientation}
          previewAreaRef={previewAreaRef}
        />
      </Box>
    </>
  )
}
